import { environment } from "../../environments/environment";
import { Renderer2, ElementRef } from '@angular/core';
declare var mapboxgl;
// load scripts post app component load
export class LoadScriptsPostAppComponentLoad {
  static stripePromise: Promise<boolean>;
  // static init() {
  //   this.userIpAddress();
  // }

  // private static userIpAddress() {
  //   const script = document.createElement('script');
  //   script.defer=true;
  //   script.async=true;
  //   script.src = 'https://jsonip.com/callback=getIP';
  //   document.head.appendChild(script);
  // }

  static stripe(document:HTMLDocument, renderer: Renderer2, el: ElementRef): Promise<boolean> {
    this.stripePromise = new Promise((resolve, reject) => {
      if (document.getElementById('stripeScript')) return resolve(true);
      const body = renderer.parentNode(el.nativeElement)
      const script = renderer.createElement('script');
      script.id = "stripeScript"
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      script.defer = true;
      script.onload = () => { resolve(true); }
      renderer.appendChild(body, script);
    })
    return this.stripePromise;
  }

  // static googleAnalytics() {
  //   return new Promise((resolve, reject) => {
  //     if (document.getElementById('gaScript')) return resolve(true);
  //     const script = document.createElement('script');
  //     script.id = "gaScript";
  //     script.type = "text/javascript";
  //     script.defer = true;
  //     script.src = 'https://www.googletagmanager.com/gtag/js?id=G-G7FVYSYEEP';
  //     script.onload = () => { resolve(true); }
  //     document.head.appendChild(script);

  //   });
  // }

  // static netcore(): Promise<boolean> {
  //   return new Promise((resolve, reject) => {
  //     if (document.getElementById('smartech')) return resolve(true);

  //     const script = document.createElement('script');
  //     script.id = "smartech";
  //     script.defer = true;
  //     script.type = "text/javascript"
  //     script.src = 'https://cdnt.netcoresmartech.com/smartechclient.js';
  //     script.onload = () => { resolve(true); }
  //     document.head.appendChild(script);
  //   })
  // }
  constructor() {}
  hippo(): Promise<boolean> {
    let hippo_url;
    // const config = this.sessionService.get('config');
    // const protoCol: string = (location && location.protocol && ['http:', 'https:'].includes(location.protocol)) ? location.protocol : 'https:';
    
      if (environment.production) { hippo_url = 'https://chat.hippochat.io/js/widget.js'; }
      else if(environment.beta)
      {
       hippo_url='https://scripts-beta.hippochat.io/public/js/widget-beta.js';
      }
      else
      {
      hippo_url = 'https://scripts-beta.hippochat.io/public/js/widget-beta.js';
      }
    return new Promise((resolve, reject) => {
    if (document.getElementById('hippoScript')) return resolve(true);
    
    const script = document.createElement('script');
    script.id = "hippoScript";
    script.src = hippo_url;
    script.defer = true;
    script.onload = () => { resolve(true); }
    document.head.appendChild(script);
    })
    }
    

  static loadFlightmapJs(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (document.getElementById("fm-map-js"))
        return resolve(true);
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.defer = true;
      script.id = "fm-map-js";
      script.src = "https://maps.flightmap.io/flightmapjs"; //flightmap.js //not from dist
      script.onload = () => {
        resolve(true);
        setTimeout(()=> {
          if( mapboxgl && mapboxgl.getRTLTextPluginStatus()=="unavailable"){
            mapboxgl.setRTLTextPlugin(
            'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
            null,
            true // Lazy load the plugin
            );
            }
        });
      };
      document.head.appendChild(script);
    });

  }
  
}
